export const rootActionTypes = {
  CLEAR_STORE: 'root/CLEAR_STORE',
};
